import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Components/Header/header";
import "./addnewemp.css";
import * as XLSX from "xlsx";

const AddNewEmp = () => {
    const [fileName, setFileName] = useState("");
    const [employees, setEmployees] = useState([]);
    const [loggedInUser, setLoggedInUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const user = localStorage.getItem("user");
        if (user) setLoggedInUser(JSON.parse(user));
        else {
            alert("Please login again.");
            navigate("/login");
        }

    }, [navigate]);

    const parseDate = (val) => {
        if (!val) return null;
        if (!isNaN(val)) {
            const d = new Date((val - 25569) * 86400 * 1000);
            return d.toISOString().split("T")[0];
        }
        const d = new Date(val);
        return isNaN(d) ? null : d.toISOString().split("T")[0];
    };

    const calculateAge = (dob) => {
        if (!dob) return "";
        const birthDate = new Date(dob);
        const diffMs = Date.now() - birthDate.getTime();
        const ageDt = new Date(diffMs);
        return Math.abs(ageDt.getUTCFullYear() - 1970);
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setFileName(file.name);

        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            const parsedData = jsonData.map((row) => {
                const dateFields = [
                    "joining_date",
                    "dob",
                    "policy_start_date",
                    "policy_end_date",
                    "last_working_date",
                ];
                dateFields.forEach((field) => {
                    if (row[field]) row[field] = parseDate(row[field]);
                });
                row.age = calculateAge(row.dob);
                return row;
            });

            setEmployees(parsedData);
        };
        reader.readAsArrayBuffer(file);
    };

    const handleSave = async () => {
        if (employees.length === 0) {
            alert("Please upload employees before saving!");
            return;
        }

        if (!loggedInUser?.emp_id) {
            alert("User details missing. Please login again.");
            navigate("/login");
            return;
        }

        try {
            const res = await fetch("/api/add-employees", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    emp_id: loggedInUser.emp_id, // send logged-in user emp_id
                    employees: employees,
                }),
            });

            const data = await res.json();

            if (res.ok) {
                alert("✅ Employees added successfully to your organization!");
                navigate(-1);
            } else {
                alert("❌ Failed to save employees: " + (data.error || res.statusText));
            }
        } catch (err) {
            console.error("Error saving employees:", err);
            alert("❌ Error saving employees, check console.");
        }
    };

    const handleDownload = () => {
        window.open("/api/download-template", "_blank");
    };

    return (
        <div className="addnewemp-page">
            <aside className="sidebar">
                <Header />
            </aside>

            <div className="addnewemp-container">
                <h2>Upload Employee Master Data</h2>
                <p>Download the template, fill in employee details, and upload the Excel file.</p>

                <div className="upload-section">
                    <button className="employee-btn employee-download" onClick={handleDownload}>
                        Download Template
                    </button>

                    <label className="employee-btn employee-upload">
                        Upload Excel
                        <input type="file" accept=".xls,.xlsx" onChange={handleFileUpload} hidden />
                    </label>
                </div>

                {fileName && <p className="employee-file-name">Uploaded: {fileName}</p>}

                {employees.length > 0 && (
                    <div className="employee-table card">
                        <h4>Preview Employees</h4>
                        <table>
                            <thead>
                                <tr>
                                    {Object.keys(employees[0]).map((col, i) => (
                                        <th key={i}>{col}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {employees.map((emp, idx) => (
                                    <tr key={idx}>
                                        {Object.keys(emp).map((col, i) => (
                                            <td key={i}>{emp[col]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className="employee-popup-footer">
                    <button
                        className={`employee-btn employee-submit ${employees.length === 0 ? "org-disabled-btn" : ""}`}
                        onClick={handleSave}
                        disabled={employees.length === 0}
                    >
                        Save
                    </button>

                    <button className="employee-btn employee-cancel" onClick={() => navigate(-1)}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddNewEmp;
